<ng-container [ngSwitch]="buttonType">
    <button *ngSwitchCase="'standard'" mat-button [matTooltip]="menuTitle || '' | transloco" [color]="buttonColor" [matMenuTriggerFor]="menu">
        <mat-icon [color]="buttonColor">{{ buttonIcon }}</mat-icon>
    </button>
    <button *ngSwitchCase="'flat'" mat-flat-button [matTooltip]="menuTitle || '' | transloco" [color]="buttonColor" [matMenuTriggerFor]="menu">
        <mat-icon [color]="buttonColor">{{ buttonIcon }}</mat-icon>
    </button>
    <button
        *ngSwitchCase="'icon'"
        mat-icon-button
        [matTooltip]="menuTitle || '' | transloco"
        [color]="buttonColor"
        [matMenuTriggerFor]="menu"
        (menuOpened)="menuOpened.emit()"
        (menuClosed)="menuClosed.emit()"
    >
        <mat-icon [color]="buttonColor">{{ buttonIcon }}</mat-icon>
    </button>
</ng-container>
<mat-menu #menu="matMenu" class="column-toggle-menu">
    <div class="item-wrapper" [class.checkboxes]="useCheckboxes" (click)="$event.stopPropagation()">
        <ng-container *ngIf="tableConfig?.displayedColumns$ | async as displayedColumns">
            <ng-container *ngFor="let columnGroup of tableConfig?.columnGroups">
                <span class="group-title" *ngIf="columnGroup.title">{{ columnGroup.title | transloco }}</span>
                <ng-container *ngFor="let column of columnGroup.columns">
                    <ng-container *ngIf="column.toggleable" [ngSwitch]="useCheckboxes">
                        <!--with checkbox-->
                        <mat-checkbox
                            *ngSwitchCase="true"
                            [checked]="(tableConfig?.displayedColumns$ | async)?.indexOf(column.key) > -1"
                            (change)="toggleColumn(column.key)"
                            class="example-margin"
                            [color]="selectorColor"
                        >
                            {{ column.label | transloco }}
                        </mat-checkbox>
                        <!--without checkbox-->
                        <ng-container *ngSwitchCase="false">
                            <button mat-menu-item (click)="toggleColumn(column.key)">
                                <mat-icon class="column-icon" [class.hidden]="displayedColumns.indexOf(column.key) === -1" [color]="selectorColor"
                                    >{{ displayedColumns.indexOf(column.key) > -1 ? 'visibility' : 'visibility_off' }}
                                </mat-icon>
                                {{ column.label | transloco }}
                            </button>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
    <div class="menu-controls">
        <button mat-icon-button [matTooltip]="resetTitle || '' | transloco" (click)="onReset($event)">
            <mat-icon [color]="buttonColor">settings_backup_restore</mat-icon>
        </button>

        <button mat-icon-button [matTooltip]="submitTitle || '' | transloco">
            <mat-icon [color]="buttonColor">check</mat-icon>
        </button>
    </div>
</mat-menu>
